/* Copyright (c) 2023 Xperi. All Rights Reserved. */

// TODO: We should remove the disbaled linters once we use these enums.
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum OverlayTypes {
    // TODO: we need to remove this
    // Please don't add more opetion here as it need to be removed.
    APP_CRASH,
    AUDIO_TRACK,
    CHANNEL_OPTIONS,
    ERROR,
    EXIT_CONFIRMATION,
    LANGUAGE_NOT_SUPPORTED,
    NO_NETWORK,
    NON_BLOCKING_ERROR,
    RECORD,
    RESET_APP,
    SIGN_IN_ERROR,
    SIGN_OUT,
    SIGN_OUT_ERROR,
    SUBTITLE_AND_CC_LANGUAGE,
    TEMPORARY_GUIDE_ISSUE,
    VOID,
    VOD_RESUME_START_OVER,
}
